module.exports = require("@embroider/util");